import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Admin from '../views/Admin.vue'
import Customers from '../views/Customers';
import Technicians from '../views/Technicians';
import Periods from '../views/Periods';
import Login from '../views/Login';
import JobSheets from '../views/JobSheets';
import PrintView from '../views/PrintView';
import PrintOne from '../views/PrintOne';
import PrintAll from '../views/PrintAll';
import WeekSheet from "@/views/WeekSheet";
import Commission from "@/views/Commission";
import store from '../store/store';
import Contracts from "@/views/Contracts";
import Scripts from "@/views/Scripts";
import AnnualTechnicianReport from "@/views/AnnualTechnicianReport";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/work',
    name: 'work',
    component: JobSheets,
    meta: { requiresAuth: true }
  },
  {
    path: '/work/print/all/:date/:tech',
    name: 'printAll',
    component: PrintAll,
    meta: { requiresAuth: true }
  },
  {
    path: '/work/print/:id/:day',
    name: 'print',
    component: PrintView,
    meta: { requiresAuth: true }
  },
  {
    path: '/work/:id',
    name: 'printOne',
    component: PrintOne,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: { requiresAuth: true }
  },
  {
    path: '/technicians',
    name: 'technicians',
    component: Technicians,
    meta: { requiresAuth: true }
  },
  {
    path: '/periods',
    name: 'periods',
    component: Periods,
    meta: { requiresAuth: true }
  },
  {
    path: '/scripts',
    name: 'scripts',
    component: Scripts,
    meta: { requiresAuth: true }
  },
  {
    path: '/week',
    name: 'week',
    component: WeekSheet,
    meta: { requiresAuth: true }
  },
  {
    path: '/commission',
    name: 'commission',
    component: Commission,
    meta: { requiresAuth: true }
  },
  {
    path: '/annual',
    name: 'annual',
    component: AnnualTechnicianReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/contracts/:id',
    name: 'contracts',
    component: Contracts
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.app.loggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  }
  next();
});

export default router
